import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import './i18n';
import App from './App.tsx'
import './index.css'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
        sendDefaultPii: false
    });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <StrictMode>
        <App />
    </StrictMode>,
)
